import PROFILE from './info/profile'

const COLLECTION_ICONS_DIR = '/static/img/recommend/lp/common/collection_icons/'
export const colorScheme = {
  keyColor: '#826A95',
  second: '#FFC0BD',
  gradStart: '#C39FE0',
  gradEnd: '#FFC0BD',
  baseBg: '#826A95', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
  infoBg: '#f1f8ff',
  messBg: '#FFECEB',
  profileKeyColor: '#FF9B96',
}

const pathCommon = '/static/img/recommend/lp/common/'
const pathCounselor = '/static/img/recommend/lp/kanoucoco/'
const deco = ''
const kira = `${pathCounselor}kira.png`
const counselor = `${pathCounselor}counselor.png`

const SUBSC_MENU_NUM = 68 //サブスクメニュー数

const hero = {
  pc: `${pathCounselor}top_sp_20220728.webp`,
  sp: `${pathCounselor}top_sp_20220728.webp`,
  fallback_pc: `${pathCounselor}top_sp_20220728.jpg`,
  fallback_sp: `${pathCounselor}top_sp_20220728.jpg`,
  alt: '叶ここの天宝占術',
}

const about = {
//  deco: deco,
  img: `${pathCounselor}about.webp`,
  headline: '占い監修：叶ここ',
  text: 'スペイン人魔術師の祖父、フィリピン人祈祷師の祖母を持つ、魔女占い師。<br>自然の力を生かすナチュラルマジックを得意とし、人生を豊かに生きるための方法の１つとして魔法の世界を伝えている。<br>そのリーディングは、相談者が語る現実のさらに奥にある因縁を的確につかみ、言葉でほぐしていく。',
  note: 'BaseCamp：「<a href="https://uranai-salon.jp/salons/14/detail" target="_blank">叶うは此処</a>」',
}

const fortune = {
  // deco: deco,
  // headline: '天宝占術とは',
  text: '「人は誰しも天の宝を持って生まれてくる」という考えのもと、天から授かった魅力を紐解きます。そのままの自分を愛し、幸せな未来を手にする方法がわかります。',
  kira,
  you: {
    // headline: '天宝占術でわかる<br>あなたのこと',
    // text: '天宝占術はあなたの人生を決して否定せず、そのままのあなたを愛する方法を教えます。',
    // comment: '生き方も、恋愛も、人の数だけ違いがあります。<br>そこに正しいも間違いもありません。<br>あなたらしく、好きに生きていく道をお伝えするのが私の占いです。',
    // counselorImage: counselor,
    avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        label: 'サフラン',
        text: '愛されたい、心の拠り所が必要',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        label: 'ローズ',
        text: '自分のこだわりを突き詰めているときが幸せ',
      },
    ],
    // advice: '自分の運命を組み立てて、<br>幸せを掴みに行きましょう。',
  },
  method: {
    // headline: '天宝占術で<br>あなたの幸せへの道筋を<br>見つけましょう',
    // text: '天宝占術は、あなたが天から授かった魅力を教えます。それは、自分を愛するための、一人一人が持つ大切な宝石。<br>あなたが人生を豊かに生きて、幸せになるための道筋です。',
    // counselorImage: counselor,
    // avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka3.png`,
        label: 'アンバー',
        text: '強く見られがちだけど本当は繊細',
      },
      {
        icon: `${pathCounselor}img_kekka4.png`,
        label: 'ラピスラズリ',
        text: '信用できる人を味方にすると活躍できる',
      },
    ],
    // advice: 'あなたの魂の形<br>魂の輝き<br>お話しましょう',
  },
  // free: {
  //   text: '自分のタイプが気になった方は、こちらから診断できますよ',
  //   img: `${pathCounselor}counselor2.png`,
  // }
}

const review = {
//  deco: deco,
}

const menu = {
  title: '叶ここの占いを<br>見てみる',
//  deco: deco,
}

const uTV = {
//  deco: deco,
  counselorImage: `${pathCounselor}counselor3.png`,
  lead: 'あなたのさらなる<br>幸せへの近道',
  resultBottomCap: `${PROFILE.name}の占いが<br>月額528円（税込）で<br>${SUBSC_MENU_NUM}メニュー占い放題！`
}

export const reviews = [
  { icon: `${pathCommon}icon_review1.png`, review: 'ドンピシャです…。思い当たる事がありすぎる心が痛い' },
  { icon: `${pathCommon}icon_review2.png`, review: '叶ここさんの占いは、背中を押されているような気持ちになります。ここさんの言葉が自分のなかで今ほしい言葉を言ってくれているような気がします。' },
  { icon: `${pathCommon}icon_review3.png`, review: '「もっと幸せになろう」と、ちゃんとアドバイスできる叶ここさん。悪い結果が出た後のアプローチ方法もしっかりしていて安心できた。' },
]

const title = {
  subTitle: '天から授かった魅力がわかる',
  title: '叶ここの天宝占術'
}

const fortuneResult = {
  lead: 'あなたの外に見せる魅力<br>アピアランスは'
}

const snsShare = {
  lead: '占いが気に入ったらシェア'
}

const leadMenu = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor4.png`,
  comment: '<b>あなたのアピアランスはわかりましたか？<br><br>ジュエルを知れば大切にすべきものがわかります</b>',
  // lead: 'あなたのこと、<br>大切な人とのことを<br>詳しく見るなら',
}

const aboutType = {
  // deco: deco,
  title: '叶ここの天宝占術',
  lead: '内に秘めた力<br>ジュエルは'
}

const leadSubsc = {
  // deco: deco,
}

// const advice = {
//   deco: deco,
//   counselorImage: `${pathCounselor}counselor5.png`,
// }

const title2 = {
  // deco: deco,
  subTitle: '＼あなたの周りの人は何タイプ？／',
  title: '叶ここの天宝占術で<br>占ってみよう'
}

const floatingBanner = {
  enable: false,
  title: '<span class="name">叶ここ</span>の<span class="emphasis">天宝占術</span>で',
  freeBtnFace: '魅力を占う（無料）',
  colors: {
    background: colorScheme.messBg,
    baseText: colorScheme.baseBg,
    emphasis: '#ff9b96',
    decos: colorScheme.baseBg,
    freeBtn: '#ff9b96',
    freeBtnBg: 'white',
  }
}

const menuDetails = {
  colors: {
    headBg: colorScheme.keyColor,
    headColor: 'white',
    baseBg: 'white',
    baseColor: colorScheme.keyColor,
    resultBg: '#f5f5f5',
  },
  contents: [
    { icon: `${COLLECTION_ICONS_DIR}icon_collection1.png`, description: '二人の宿縁と出会った理由' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection2.png`, description: '最も向いている職業と<br>仕事で活かせる能力' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection3.png`, description: '結婚したいと思わせる<br>あなたの魅力' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection4.png`, description: 'あなたが人生で築く財産' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection5.png`, description: '今後起こるトラブルと<br>その対処法' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection6.png`, description: 'あなたが手に入れる<br>“人生において大切なもの”' },
  ],
}

const tabedMenu = {
  color: {
    baseColor: colorScheme.keyColor,
    itemFont: colorScheme.keyColor,
    frameColor: colorScheme.keyColor,
  }
}

const lineBanner = {
  bannerUrl: '/static/img/recommend/lp/banner/kanococo_line_20220316.png'
}

const uTvDesc = {
  leadImg: `${pathCounselor}counselor5.png`,
  lead:
    'いかがでしたか？<br>天宝占術はあなたの人生を決して否定せず、そのままの自分を愛する方法を伝えます。<br>生き方も、恋愛も、人の数だけ違いがあるんだから。<br>まずは自分を知り、未来を知れば、今悩んでいることへの答えも自然とみえてくるはず。<br><br>次は、あなたが持って生まれた「仕事の才能」、今後直面する「人生の分岐点」について、もう少しお伝えさせてくださいね。',
  points: [
    {
      img: `${pathCounselor}uTVdesc/point1.png`,
      copy: `${pathCounselor}uTVdesc/point1_copy.png`
    },
    {
      img: `${pathCounselor}uTVdesc/point2.png`,
      copy: `${pathCounselor}uTVdesc/point2_copy.png`
    },
    {
      img: `${pathCounselor}uTVdesc/point3.png`,
      copy: `${pathCounselor}uTVdesc/point3_copy.png`
    },
    {
      img: `${pathCounselor}uTVdesc/point4.png`,
      copy: `${pathCounselor}uTVdesc/point4_copy.png`
    },
    {
      img: `${pathCounselor}uTVdesc/point5.png`,
      copy: `${pathCounselor}uTVdesc/point5_copy.png`
    },
    {
      img: '__ex__',
      copy: `${pathCounselor}uTVdesc/point6_copy.png`,
      extend: `<img src="${pathCounselor}uTVdesc/point6_copy_pre.png"><div class="seimei"><video src="https://s3-ap-northeast-1.amazonaws.com/uranaitv-town-dev/lp/video_letter/fast/seimei.mp4" autoplay loop muted playsinline></video></div>`
    }
  ]
}

export const information = {
  name: PROFILE.name, // ※互換のため残すが以降についてはprofile.nameを使用すること
  mainMethod: PROFILE.mainMethod, // ※互換のため残すが以降についてはprofile.mainMethodを使用すること
  profile: PROFILE,
  hero,
  about,
  fortune,
  review,
  reviews,
  menu,
  uTV,
  title,
  fortuneResult,
  snsShare,
  leadMenu,
  aboutType,
  leadSubsc,
  // advice,
  title2,
  floatingBanner,
  menuDetails,
  tabedMenu,
  lineBanner,
  uTvDesc
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/counselorInfos.js